<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_iv"></a>Farrar, Straus and Giroux<br/>18 West 18th Street, New York 10011</p>
<p class="para"> </p>
<p class="center-para">Copyright © 2009 by Stephen Amidon<br/>All rights reserved<br/>Distributed in Canada by Douglas &amp; McIntyre Ltd.<br/>Printed in the United States of America<br/>First edition, 2009</p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para">Amidon, Stephen.</p>
<p class="indent-para">Security / Stephen Amidon.— 1st ed.</p>
<p class="indent-para">    p.   cm.</p>
<p class="indent-para">ISBN-13: 978-0-374-25711-8 (hardcover : alk. paper)</p>
<p class="indent-para">ISBN-10: 0-374-25711-6 (hardcover : alk. paper)</p>
<p class="indent-para">1. Spouses—Fiction. 2. New England—Fiction. 3. Domestic fiction. I. Title.</p>
<p class="para">  PS3551.M52 S43 2009</p>
<p class="para">  813'.54—dc22</p>
<p class="right-para">2008013850</p>
<p class="para"> </p>
<p class="center-para">Designed by Jonathan D. Lippincott</p>
<p class="para"> </p>
<p class="center-para"><a href="http://www.fsgbooks.com" target="_blank">www.fsgbooks.com</a></p>
<p class="para"> </p>
<p class="center-para">1  3  5  7  9  10  8  6  4  2</p>
<p class="para"> </p>
<p class="center-para">The author would like to express his gratitude to the<br/>Corporation of Yaddo for its generous support.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?172b2df6